import { render, staticRenderFns } from "./KelasForm.vue?vue&type=template&id=494b81d4"
import script from "./KelasForm.vue?vue&type=script&lang=js"
export * from "./KelasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports